import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import type { Currency } from "../data/BaseEntity";
import dayjs, { ISO_DATE_FORMAT } from "../dayjs";
import { getExchangeRatesFor, getLatestExchangeRates } from "./exchangeRatesApi";

function getExchangeRates(date: string, baseCurrency: "EUR" | "PLN" | undefined, abortSignal?: AbortSignal) {
  if (baseCurrency === undefined) {
    return null;
  }
  return date && date < today()
    ? getExchangeRatesFor(baseCurrency, date, abortSignal)
    : getLatestExchangeRates(baseCurrency, abortSignal);
}

export const useExchangeRates = (baseCurrency: Currency, date: string | null) => {
  const { enqueueSnackbar } = useSnackbar();
  const { data, isLoading, error } = useQuery({
    queryKey: ["exchange-rates", baseCurrency, date ?? "latest"],
    queryFn: ({ signal }) => getExchangeRates(date ?? "", baseCurrency, signal),
  });

  useEffect(() => {
    if (!isLoading && error) {
      const message = date
        ? `Nie udało się pobrać kursów walut z ${date}. Powód: ${error.message}`
        : `Nie udało się pobrać aktualnych kursów walut. Powód: ${error.message}`;
      enqueueSnackbar(message, { variant: "error" });
    }
  }, [isLoading, error]);

  return { exchangeRates: data, isLoading };
};

function today() {
  return dayjs().format(ISO_DATE_FORMAT);
}
